import { useEscapeKey } from "./useEscapeKey";
import { useBodyScrollLock } from "../../../hooks/useBodyScrollLock";
import { useHeaderBehindModal } from "../../../hooks/useHeaderBehindModal";
import { IconX } from "../../../components/ui/Icons";

export default function ImageModal({ src, alt, onClose }) {
  useBodyScrollLock(true);
  useHeaderBehindModal(true);
  useEscapeKey(onClose);
  return (
    <div className="imgModalBackdrop" role="dialog" aria-modal="true" aria-label="Podgląd zdjęcia" onClick={onClose}>
      <div className="imgModalShell" onClick={(event) => event.stopPropagation()}>
        <div className="imgModalHd">
          <div className="imgModalTitle">Podgląd zdjęcia</div>
          <button type="button" className="modalCloseBtn" onClick={onClose} aria-label="Zamknij"><IconX /></button>
        </div>
        <div className="imgModalBd"><img className="imgFull" src={src} alt={alt || "Zdjęcie"} /></div>
      </div>
    </div>
  );
}
